import type { TableProps } from 'antd'
import { useState } from 'react'

export interface TableSort<K extends string> {
    columnKey: K
    order: 'ascend' | 'descend'
}

/**
 * Кероване сортування таблиці звіту: стан живе на сторінці (не губиться при перемонтуванні
 * таблиці після помилки), а експорт отримує той самий порядок — `sort`/`order` у query.
 */
export const useTableSort = <K extends string, T = any>() => {
    const [sort, setSort] = useState<TableSort<K> | null>(null)

    /** `sortOrder` колонки з ключем `key` */
    const sortOrder = (key: K): TableSort<K>['order'] | null => (sort?.columnKey === key ? sort.order : null)

    const onChange: NonNullable<TableProps<T>['onChange']> = (_pagination, _filters, sorter) => {
        const active = Array.isArray(sorter) ? sorter[0] : sorter
        setSort(active?.order && active.columnKey ? { columnKey: active.columnKey as K, order: active.order } : null)
    }

    /** Параметри експорту; без сортування — порожньо (порядок звіту) */
    const sortParams: Record<string, string> = sort ? { sort: sort.columnKey, order: sort.order } : {}

    return { sort, sortOrder, onChange, sortParams }
}
